import { getRecoil } from 'recoil-nexus';
import { marketCode, userGroupsCode } from '../Recoil-State';
import { uniq, min } from 'lodash';

let usersPriority = {
    CU: 5,
    MU: 4,
    MKU: 3,
    MA: 2,
    SA: 1
}
const status = [
    'Approved for Use',
    'Approved',
    'Approved for Distribution',
    'MLR Approved',
    'MLR Approved with Changes'
];

let userRoleFilters = {
    MKU: status,
    MA: status
}

export const getSelectedFilterList =(items) => {
    let currentFilters =[];
    let Updated_Filters = [];
    items.forEach(({label, items})=> {
        if ( label ==='Approval Status') {
            currentFilters.push(...items);
        }
    });

    let MARKETCODE = getRecoil(marketCode);
    let Roles = getLoginUserRole(MARKETCODE);
    let filterRole = Object.keys(userRoleFilters);
    if ( filterRole.includes(Roles)) {
        currentFilters.forEach(({label})=> {
            if (status.includes(label)) {
                Updated_Filters.push(label);
            }
        });

    }

    Updated_Filters = uniq(Updated_Filters);
    return {approval_status:Updated_Filters};

}

const getAssignRoles = (MARKETCODE) => {
    let users = Object.keys(usersPriority);
    let assignRoles = [];
    const groupCode = getRecoil(userGroupsCode);
    if (groupCode) {
        groupCode.forEach(ele => {
            let arr = ele.split('_');
            // check global access
            let isValid = (arr.indexOf(MARKETCODE) > 0 || arr.indexOf('GBL') > 0) ? true : false;
            if (isValid) {
                users.forEach(role => {
                    if (arr.includes(role)) {
                        let num = usersPriority[role]// add rolenumber
                        assignRoles.push(num)
                    }
                });
            }
        });
        assignRoles = uniq(assignRoles);
    }
    return assignRoles;
}

export const getLoginUserRole = (MARKETCODE) => {
    let role = '';
    let assignRoles = getAssignRoles(MARKETCODE);
    if (assignRoles && assignRoles.length) {
        let number = min(assignRoles);
        let index = Object.values(usersPriority).findIndex(num => num === number);
        let roleArr = Object.keys(usersPriority);
        role = roleArr[index];
    }

    return role;
}